<template>
  <section class="flex flex-nowrap space-x-3 pt-8">
    <Button
      :icon-name="'share'"
      :text="'Copy to clipboard'"
      :icon="'only-icon'"
      :type="'outline-fade'"
      :radius="'semi-rounded'"
      :size="'small'"
      @click.stop="copyURL(store.state.pageFullPath)"
    />
    <ShareButton :icon-name="'twitter'" :text="''">
      <ShareNetwork
        class="absolute inset-0"
        network="twitter"
        :url="store.state.pageFullPath"
        :title="store.state.pageTitle"
      >
        <span class="sr-only" v-text="'Share on Twitter'" />
      </ShareNetwork>
    </ShareButton>
    <ShareButton :icon-name="'facebook'" :text="''">
      <ShareNetwork
        class="absolute inset-0"
        network="facebook"
        :url="store.state.pageFullPath"
        :title="store.state.pageTitle"
      >
        <span class="sr-only" v-text="'Share on Facebook'" />
      </ShareNetwork>
    </ShareButton>
    <ShareButton :icon-name="'linkedin'" :text="''">
      <ShareNetwork
        class="absolute inset-0"
        network="linkedin"
        :url="store.state.pageFullPath"
        :title="store.state.pageTitle"
      >
        <span class="sr-only" v-text="'Share on LinkedIn'" />
      </ShareNetwork>
    </ShareButton>
  </section>
</template>

<script setup lang="ts">
import { useStore } from 'vuex'

const store = useStore()

async function copyURL(url: string) {
  try {
    await navigator.clipboard.writeText(url)
    store.dispatch('toastSuccess', { message: 'Copied to clipboard' })
  } catch (e) {
    store.dispatch('toastDanger', { message: 'Cannot copy' })
  }
}
</script>

<style scoped lang="scss"></style>
